<template>
    <div class="orderItem">
        <div class="orderItem-top">
            订单号：{{info.orderNo}}
            <!-- <a :href="detailUrl" target="_blank">{{info.orderNo}}</a> -->
            <span class="orderItem-top-status">{{info.statusName||info.orderStatusDesc||''}}</span>
        </div>
        <div class="orderItem-body">
            <div class="orderItem-body-flex">
                <div class="orderItem-body-flex-1 orderItem-body-title">
                    {{info.productName}}
                    <span class="orderItem-body-subtitle"
                        v-if="info.extraInfo&&info.extraInfo[0]&&info.extraInfo[0].scheme">
                        {{info.extraInfo[0].scheme}}</span>
                </div>
                <div class="orderItem-body-flex-1 align-right">
                    订单创建时间：{{info.createTime}}
                </div>
            </div>
            <div class="orderItem-body-flex">
                <div class="orderItem-body-flex-1">
                    订单金额：<span class="price-color">{{info.orderAmount||info.totalAmount||'0'}} 元</span>
                </div>
                <div class="orderItem-body-flex-1 align-right">
                    <!-- status：2已支付 11对公支付的已支付还未确认 -->
                    <span v-if="isPaid">订单支付时间：{{info.paymentTime}}</span>
                    <Button 
                        type="primary" 
                        size="small" 
                        @click="toPay(info.orderNo)" 
                        v-if="info.bizId=='JIANGONG_DEPOSIT'&&info.orderStatus=='UNPAID'">立即支付</Button>
                    <!-- <Button size="small" @click="toCancel(info.orderNo)" v-if="info.productCode.indexOf('APP')==-1&&isUnpaid">取消订单</Button> -->
                    <a :href="'/haierProduct.html#/my/taskDetail/'+info.insuranceApplicationId" target="_blank">投保单详情</a>
                    <a v-if="info.bizId=='JIANGONG_DEPOSIT'&&info.orderStatus=='PAID'&&(info.invoiceStatus=='NOT')" @click="toInvoice(info)">申请开票</a>
                </div>
            </div>
            <div class="orderItem-body-flex" v-if="isPaid">
                <div class="orderItem-body-flex-1 align-right">
                    支付方式：{{info.payTypeName||info.paymentSourceDesc}}
                </div>
            </div>
            <div class="orderItem-body-flex" v-if="isPaid">
                <div class="orderItem-body-flex-1" v-if="info.pointAmount">
                    抵扣金额：<span class="price-color">{{info.pointAmount||0}} 元</span>
                </div>
                <div class="orderItem-body-flex-1 align-right">
                    支付金额：<span class="price-color">{{info.amount||info.buyerPayAmount||0}} 元</span>
                </div>
            </div>
        </div>
        <Modal v-model="invoiceShow" title="发票信息" width="600px" :mask-closable="false">
			<Form :model="invoiceForm" ref="invoiceForm" :label-width="120" :rules="invoiceFormRules">
                <FormItem label="发票信息" prop="invoiceType">
					<RadioGroup v-model="invoiceForm.invoiceType">
                        <Radio label="PLAIN">电子发票</Radio>
                        <Radio label="VAT">纸质发票</Radio>
                    </RadioGroup>
				</FormItem>
				<FormItem label="公司名称" prop="invoiceName" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceName: [{ required: false }]">
					<Input type="text" disabled  v-model="invoiceForm.invoiceName"></Input>
				</FormItem>
				<FormItem label="统一社会信用代码" prop="invoiceUniqueCode" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceUniqueCode: [{ required: false }]">
					<Input type="text" disabled v-model="invoiceForm.invoiceUniqueCode"></Input>
				</FormItem>
				<FormItem label="开户地址" prop="invoiceAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceAddress: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceAddress" placeholder="请输入开户地址" :maxlength="50"></Input>
				</FormItem>
				<FormItem label="联系电话" prop="invoicePhone" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoicePhone: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoicePhone" placeholder="请输入联系电话" :maxlength="20"></Input>
				</FormItem>
                <FormItem label="开户行" prop="openingBankName" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankName: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankName" placeholder="请输入开户行" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="对公账号" prop="openingBankAccount" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.openingBankAccount: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.openingBankAccount" placeholder="请输入对公账号" :maxlength="30"></Input>
				</FormItem>
                <FormItem label="电子邮箱" prop="invoiceDeliverEmail" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverEmail: [{ required: false }]">
					<Input type="text" v-model="invoiceForm.invoiceDeliverEmail" placeholder="请输入电子邮箱" :maxlength="100"></Input>
				</FormItem>
                <FormItem label="邮寄地址" prop="invoiceDeliverAddress" :rules="invoiceForm.invoiceType == 'VAT'? invoiceFormRules.invoiceDeliverAddress: [{ required: false }]">
					<Input type="text" placeholder="填写内容需要包含邮寄人姓名、电话与邮寄地址" v-model="invoiceForm.invoiceDeliverAddress" :maxlength="100"></Input>
				</FormItem>
			</Form>
			<template slot="footer">
				<Button type="text" @click="cancalInvoice">取消</Button>
				<Button type="primary" @click="handleSubmit('invoiceForm')">确定</Button>
			</template>
		</Modal>
    </div>
</template>
<script>
    import UploadFile from '@/components/common/UploadFileImg'
    export default {
        components: { UploadFile },
        props: {
            info: {
                type: Object,
                default () {
                    return {}
                }
            },
        },
        data () {
            return {
                show: false,
                show2: false,
                form2: {
                    list0: [{ fileType: 'APPLICATION_COMFIRM' }], //投保确认书
                    list1: [{ fileType: 'APPLICATION' }], //投保单
                    list2: [{ fileType: 'STATEMENTS' }], //结算单/内结单
                    list3: [{ fileType: 'POLICY' }], //保单
                    list4: [{ fileType: 'INVOICE' }],//发票
                    list5: [{ fileType: 'ENDORSE' }],//批改单
                    list6: [{ fileType: 'ENDORSE_POLICY' }],//批改保单
                },
                list: [],
                columnsFileList: [
                    { title: '文件名称', key: 'fileName' },
                    { title: '上传时间', key: 'createTime' },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 80,
                        align: 'center'
                    }
                ],
                invoiceShow:false,
                invoiceForm:{
                    invoiceType:'PLAIN'
                },
                invoiceFormRules:{
                    invoiceName:{required:true,message:'请输入开票名称',trigger:'blur'},
                    invoiceUniqueCode:{required:true,message:'请输入统一社会信用代码',trigger:'blur'},
                    invoiceAddress:{required:true,message:'请输入开户地址',trigger:'blur'},
                    invoicePhone:{required:true,message:'请输入联系电话',trigger:'blur'},
                    openingBankName:{required:true,message:'请输入开户行',trigger:'blur'},
                    openingBankAccount:{required:true,message:'请输入对公账号',trigger:'blur'},
                    invoiceDeliverEmail:[
                        { required: true, message: '邮箱不能为空', trigger: 'blur' },
                        { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
                    ],
                    invoiceDeliverAddress:{required:true,message:'请输入邮寄地址',trigger:'blur'}
                }
            }
        },
        computed: {
            isPaid () {
                // 企业雇主责任险status，其他的orderStatus
                return this.info.status == '2' || this.info.orderStatus == 'PAID'
            },
            isUnpaid () {
                return this.info.status == 1 || this.info.orderStatus == 'UNPAID'
            },
            detailUrl () {
                if (this.info.bizId) {
                    // 通用框架
                    return `/haierProduct.html#/my/order-detail/${this.info.orderNo}/common`
                } else {
                    return `/haierProduct.html#/my/order-detail/${this.info.orderNo}`
                }
            }
        },
        methods: {
            toInvoice(row){
                if(row.invoiceInfo&&row.invoiceInfo.invoiceType=='NOT'){
                    this.invoiceShow = true;
                    this.$nextTick(()=>{
                        this.$set(this.invoiceForm,'invoiceName',row.applicantList[0].subjectName);
                        this.$set(this.invoiceForm,'invoiceUniqueCode',row.applicantList[0].idNumber);
                        this.$set(this.invoiceForm,'orderNo',row.orderNo);
                    })
                } else {
                    this.invoiceForm = row.invoiceInfo;
                    this.$set(this.invoiceForm,'orderNo',row.orderNo);
                    this.$axios.post('/broker/order/downloadInvoice.json',{
                        ...this.invoiceForm
                    }).then(res=>{
                        this.$Message.success('已提交，7个工作日内将由保司发送至您的邮箱，或邮寄至您所填写的地址');
                        this.invoiceForm = {
                            invoiceType:'PLAIN'
                        }
                        this.search();
                    }).catch(err=>{
                        this.invoiceForm = {
                            invoiceType:'PLAIN'
                        }
                    })
                }
            },
            handleSubmit (name) {
                if(this.invoiceForm.invoiceType=='VAT'){
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            this.$axios.post('/broker/order/downloadInvoice.json',{
                                ...this.invoiceForm
                            }).then(res=>{
                                this.$Message.success('申请成功!');
                                this.cancalInvoice()
                            }).catch(err=>{
                                this.cancalInvoice()
				            })
                        }
                    })
                } else {
                    let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(this.invoiceForm.invoiceDeliverEmail&&(this.invoiceForm.invoiceDeliverEmail!==''&&!reg.test(this.invoiceForm.invoiceDeliverEmail))) { 
                        this.$Message.error('请输入有效的邮箱');
                        return
                    }
                    this.$axios.post('/broker/order/downloadInvoice.json',{
                        ...this.invoiceForm
                    }).then(res=>{
                        this.$Message.success('申请成功!');
                        this.cancalInvoice()
                    })
                }
            },
            cancalInvoice(){
                this.invoiceShow = false;
                this.invoiceForm = {
                    invoiceType:'PLAIN'
                }
                this.search()
            },
            // 查看记录
            async recored () {
                this.list = []
                let obj = {
                    fileType: 'STATEMENTS',
                    applicationId: this.info.insuranceApplicationId
                }
                this.list = await this.$axios.post('/broker/attachment/listQuery.json', obj)
                this.show2 = true
            },
            // 清空表单校验
            handleReset (name) {
                this.$refs[name].resetFields()
            },
            /*上传成功回调*/
            uploaded (file, index, list, item) {
                let obj = {
                    fileUrl: file.url,
                    fileName: file.name,
                    fileType: item.fileType
                }
                if (item.fileNo) obj.fileNo = item.fileNo
                this.$set(this.form2[list], index, obj)
            },
            // 上传内结单
            showUpload (data) {
                this.show = true
            },
            // 提交
            async valid (a) {
                let valid = await this.$refs.form2.validate()
                if (valid) {
                    let obj = {}
                    obj.applicationId = this.info.insuranceApplicationId
                    if (this.info.endorseId) {
                        obj.endorseId = this.info.endorseId
                        obj.isApplication = 0
                    } else {
                        obj.isApplication = 1
                    }
                    obj.bizId = this.info.bizId
                    obj.productCode = this.info.productCode
                    obj.orderId = this.info.id
                    // obj.taskId = this.$route.query.taskId
                    // obj.isApplication = 0
                    obj.fileList = []
                    obj.fileList.push(this.form2['list' + a][0])
                    await this.$axios.post('/broker/attachment/uploadAttachmentFile.json', obj)
                    this.toast('提交成功')
                    this.show = false
                    this.$emit('on-load')
                    // this.$router.replace('/agent/my/task')
                    // this.$router.replace('/agent/my/task?status=APPLY_PROCESSING')
                }
            },
            // 立即支付
            toPay (orderNo) {
                this.confirm('立即支付？支付结果反馈存在延迟，为避免重复支付，建议您先线下确认支付状态 ', () => {
                    window.open(`/common.html#/common-pay/${orderNo}`)
                })
            },
            // 取消订单
            toCancel (orderNo) {
                this.confirm('确认取消订单？', () => {
                    let url = this.info.bizId ? '/broker/order/close' : '/employerLiability/cancelOrder.json'
                    this.$axios.post(url, {
                        orderNo: orderNo
                    }).then(res => {
                        this.toast('取消成功')
                        this.$emit('on-load')
                    });
                })
            }
        },
    }
</script>
<style scoped lang="less">
    .orderItem {
        border: 1px solid #eaeaea;
        margin-top: 10px;
        color: #333;

        &-top {
            padding: 10px;
            font-size: 14px;
            color: #aaa;
            border-bottom: 1px solid #eaeaea;

            &-status {
                float: right;
                color: #333;
            }
        }

        &-body {
            padding: 10px 0;

            &-flex {
                display: flex;
                padding: 5px 10px;
                font-size: 14px;

                &-1 {
                    flex: 1;
                }
            }

            &-title {
                font-size: 16px;
                font-weight: bold;
            }

            &-subtitle {
                font-size: 14px;
                font-weight: normal;
                color: #333;
            }

            .price-color {
                color: #FF6600;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/customized/OrderItem.vue